var mobile = require('is-mobile');

// Remove demo in mobile view
if (mobile())
{

  var frame = document.getElementById("demo-iframe");
  if (frame != null)
    frame.parentNode.removeChild(frame);
  var alert = document.getElementById("mobile-alert");
  if (alert != null)
    alert.removeAttribute("hidden");
}
